export const LIST_STATES_UF = [
    { value: 'SP', label: 'São Paulo' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'AC', label: 'Acre' },
    { value: 'AL', label: 'Alagoas' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' },
];

export const BRANDS_LIST = [
    {
        principal: true,
        id: '5efb4d8b853903000ac4ec3a',
        sql_id: 2,
        name: 'CHEVROLET',
        slugged: 'chevrolet',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ecce',
        sql_id: 5,
        name: 'VOLKSWAGEN',
        slugged: 'volkswagen',
        vehicle_type: 1,
        tenant: 76,
    },
    {
        principal: true,
        id: '5efb4d8b853903000ac4ec56',
        sql_id: 4,
        name: 'FIAT',
        slugged: 'fiat',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ec68',
        sql_id: 16,
        name: 'HONDA',
        slugged: 'honda',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ecc9',
        sql_id: 35,
        name: 'TOYOTA',
        slugged: 'toyota',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ec6b',
        sql_id: 17,
        name: 'HYUNDAI',
        slugged: 'hyundai',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ec5b',
        sql_id: 3,
        name: 'FORD',
        slugged: 'ford',
        vehicle_type: 1,
        tenant: 76,
    },
    {
        principal: true,
        id: '5efb4d8b853903000ac4ec9f',
        sql_id: 27,
        name: 'NISSAN',
        slugged: 'nissan',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ecad',
        sql_id: 30,
        name: 'RENAULT',
        slugged: 'renault',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: false,
        id: '5efb4d8b853903000ac4ec74',
        sql_id: 218,
        name: 'JEEP',
        slugged: 'jeep',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: true,
        id: '5efb4d8b853903000ac4ec96',
        sql_id: 26,
        name: 'MITSUBISHI',
        slugged: 'mitsubishi',
        vehicle_type: 1,
        tenant: 76,
    },

    {
        principal: false,
        id: '5efb4d8b853903000ac4ec29',
        sql_id: 10,
        name: 'BMW',
        slugged: 'bmw',
        vehicle_type: 1,
        tenant: 76,
    },
];

export const TYPE_CAR = 0;

export const TYPE_BIKE = 1;

export const PAGE_TYPE = {
    HOME: 'homepage',
    BRAND: 'marca',
    BIKE: 'motos',
    MODEL: 'modelo',
    VERSION: 'versão',
    RESULT: 'resultado',
};

export const USER_LOGIN_STATUS = {
    LOGGED: '1',
    LOGGED_OUT: '2',
};

export const VEHICLE_TYPE = {
    CAR: 'carro',
    BIKE: 'motos',
};

export const VEHICLE_TYPE_ENUM = {
    CAR: 1,
    BIKE: 2,
};

type ModelsByBrandType = {
    [key: string]: {
        [key: string]: {
            models: string[];
            images: string[];
        };
    };
};

const generateImagesPathDefault = () => {
    return Array.from({ length: 5 }, () => `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/bike-default.svg`);
};

export const modelsByBrand: ModelsByBrandType = {
    // carros
    carros: {
        chevrolet: {
            models: [
                'Onix',
                'S10',
                'Celta',
                'Prisma',
                'Corsa',
                'Cruze',
                'Tracker',
                'Classic',
                'Astra',
                'Spin',
                'Montana',
                'Cobalt',
            ],
            images: [
                '/348145/CHEVROLET_ONIX_1.0_TURBO_FLEX_PLUS_PREMIER_AUTOMATICO_34814517344963776.webp',
                '/348451/CHEVROLET_S10_2.8_16V_TURBO_DIESEL_HIGH_COUNTRY_CD_4X4_AUTOMATICO_34845117120924160.webp',
                '/345294/CHEVROLET_CELTA_1.0_MPFI_ADVANTAGE_8V_FLEX_4P_MANUAL_34529418254551192.webp',
                '/346816/CHEVROLET_PRISMA_1.0_MPFI_JOY_8V_FLEX_4P_MANUAL_34681618285410915.webp',
                '/344035/CHEVROLET_CORSA_1.0_MPFI_CLASSIC_SEDAN_LIFE_8V_FLEX_4P_MANUAL_34403518264909697.webp',
                '/348183/CHEVROLET_CRUZE_1.4_TURBO_FLEX_PREMIER_AUTOMATICO_3481831810096664.webp',
                '/348354/CHEVROLET_TRACKER_1.2_TURBO_FLEX_PREMIER_AUTOMATICO_34835416571169184.webp',
                '/345601/CHEVROLET_CLASSIC_1.0_MPFI_ADVANTAGE_8V_FLEX_4P_MANUAL_34560118261190026.webp',
                '/343874/CHEVROLET_ASTRA_2.0_MPFI_8V_FLEX_4P_AUTOMATICO_34387418233530269.webp',
                '/348023/CHEVROLET_SPIN_1.8_PREMIER_8V_FLEX_4P_AUTOMATICO_34802317030619094.webp',
                '/379435/CHEVROLET_MONTANA_1.2_TURBO_FLEX_RS_AUTOMATICO_37943517445631982.webp',
                '/346518/CHEVROLET_COBALT_1.8_MPFI_ELITE_8V_FLEX_4P_AUTOMATICO_34651811070635393.webp',
            ],
        },
        volkswagen: {
            models: [
                'Gol',
                'Fox',
                'Polo',
                'Saveiro',
                'Voyage',
                'T-Cross',
                'Jetta',
                'Golf',
                'Nivus',
                'Amarok',
                'Virtus',
                'up!',
            ],
            images: [
                '/349236/VOLKSWAGEN_GOL_1.0_12V_MPI_TOTALFLEX_LAST_EDITION_4P_MANUAL_34923608593742297.webp',
                '/347419/VOLKSWAGEN_FOX_1.6_MSI_TOTAL_FLEX_XTREME_4P_MANUAL_34741909043915545.webp',
                '/348298/VOLKSWAGEN_POLO_1.4_250_TSI_GTS_AUTOMATICO_34829815184651034.webp',
                '/379476/VOLKSWAGEN_SAVEIRO_1.6_MSI_EXTREME_CD_16V_FLEX_2P_MANUAL_37947615204045846.webp',
                '/347692/VOLKSWAGEN_VOYAGE_1.0_12V_MPI_TOTALFLEX_4P_MANUAL_34769208573907168.webp',
                '/347982/VOLKSWAGEN_TCROSS_1.4_250_TSI_TOTAL_FLEX_HIGHLINE_AUTOMATICO_34798216063256257.webp',
                '/348037/VOLKSWAGEN_JETTA_2.0_350_TSI_GASOLINA_GLI_DSG_34803714565259094.webp',
                '/348250/VOLKSWAGEN_GOLF_1.4_TSI_HIBRIDO_GTE_DSG_34825017380599583.webp',
                '/348395/VOLKSWAGEN_NIVUS_1.0_200_TSI_TOTAL_FLEX_HIGHLINE_AUTOMATICO_34839517523485623.webp',
                '/379740/VOLKSWAGEN_AMAROK_3.0_V6_TDI_DIESEL_EXTREME_CD_4MOTION_AUTOMATICO_37974014360009839.webp',
                '/349275/VOLKSWAGEN_VIRTUS_1.4_250_TSI_EXCLUSIVE_AUTOMATICO_34927508414460948.webp',
                '/348021/VOLKSWAGEN_UP_1.0_170_TSI_TOTAL_FLEX_XTREME_4P_MANUAL_34802108555387280.webp',
            ],
        },
        fiat: {
            models: [
                'Uno',
                'Palio',
                'Strada',
                'Toro',
                'Argo',
                'Mobi',
                'Siena',
                'Punto',
                'Cronos',
                'Grand-Siena',
                'Fiorino',
                'Pulse',
            ],
            images: [
                '/346865/FIAT_UNO_1.0_FIREFLY_FLEX_WAY_4P_MANUAL_34686510244524877.webp',
                '/343824/FIAT_PALIO_1.8_MPI_ADVENTURE_WEEKEND_16V_FLEX_4P_MANUAL_34382410231405266.webp',
                '/379460/FIAT_STRADA_1.0_TURBO_200_FLEX_ULTRA_CD_CVT_37946015501473631.webp',
                '/379911/FIAT_TORO_2.2_TURBO_DIESEL_RANCH_4WD_AT9_37991116322646791.webp',
                '/349261/FIAT_ARGO_1.3_FIREFLY_FLEX_DRIVE_CVT_34926111273181022.webp',
                '/379898/FIAT_MOBI_1.0_FIREFLY_FLEX_TREKKING_MANUAL_37989811182235441.webp',
                '/345241/FIAT_SIENA_1.4_MPI_8V_FLEX_4P_TETRAFUEL_34524114254282757.webp',
                '/345399/FIAT_PUNTO_1.8_BLACKMOTION_16V_FLEX_4P_AUTOMATIZADO_3453991426088947.png',
                '/349107/FIAT_CRONOS_1.3_FIREFLY_FLEX_PRECISION_CVT_34910715193248291.webp',
                '/344242/FIAT_GRAND_SIENA_1.4_MPI_8V_FLEX_4P_MANUAL_34424210181008325.webp',
                '/348496/FIAT_FIORINO_1.4_MPI_FURGAO_ENDURANCE_8V_FLEX_2P_MANUAL_34849615310083759.webp',
                '/379815/FIAT_PULSE_1.0_TURBO_200_HYBRID_IMPETUS_CVT_37981511134652263.webp',
            ],
        },
        honda: {
            models: ['Civic', 'Fit', 'HR-V', 'City', 'CR-V', 'WR-V', 'Accord', 'ZR-V'],
            images: [
                '/379680/HONDA_CIVIC_2.0_DI_E:HEV_ADVANCED_ECVT_37968013341746141.webp',
                '/342096/HONDA_FIT_1.5_EX_16V_FLEX_4P_AUTOMATICO_34209616414322363.webp',
                '/349076/HONDA_HRV_1.5_DI_IVTEC_TURBO_FLEX_TOURING_CVT_34907610550616611.webp',
                '/348899/HONDA_CITY_1.5_IVTEC_FLEX_TOURING_CVT_3488991529335395.webp',
                '/379623/HONDA_CRV_2.0_E:HEV_ADVANCED_ECVT_3796231054158006.webp',
                '/347107/HONDA_WRV_1.5_16V_FLEXONE_EXL_CVT_3471071645507137.webp',
                '/379521/HONDA_ACCORD_2.0_E:HEV_ADVANCED_ECVT_37952113292042089.webp',
                '/379541/HONDA_ZRV_2.0_IVTEC_GASOLINA_CVT_37954113490777379.webp',
            ],
        },
        toyota: {
            models: ['Corolla', 'Hilux', 'Etios', 'Hilux SW4', 'Yaris', 'Corolla Cross', 'Rav4', 'Prius', 'Camry'],
            images: [
                '/379444/TOYOTA_COROLLA_1.8_VVTI_HYBRID_FLEX_ALTIS_PREMIUM_CVT_37944417132188584.webp?',
                '/379551/TOYOTA_HILUX_2.8_D4D_TURBO_DIESEL_CD_SRX_PLUS_4X4_AUTOMATICO_37955118293431431.webp?',
                '/347582/TOYOTA_ETIOS_1.5_X_PLUS_SEDAN_16V_FLEX_4P_AUTOMATICO_34758215251070440.webp?',
                '/348896/TOYOTA_HILUX_SW4_2.8_D4D_TURBO_DIESEL_DIAMOND_7L_4X4_AUTOMATICO_34889611025232280.webp?',
                '/347725/TOYOTA_YARIS_1.5_16V_FLEX_SEDAN_XLS_MULTIDRIVE_34772520154718694.webp?',
                '/348628/TOYOTA_COROLLA_CROSS_1.8_VVTI_HYBRID_FLEX_XRX_CVT_34862810393967740.webp?',
                '/348345/TOYOTA_RAV4_2.5_VVTIE_HYBRID_SX_CONNECT_AWD_CVT_34834510202732869.webp?',
                '/344202/TOYOTA_PRIUS_1.8_16V_HIBRIDO_4P_AUTOMATICO_34420215100173613.webp?',
                '/349033/TOYOTA_CAMRY_2.5_VVTIE_HYBRID_XLE_ECVT_34903308042535932.webp?',
            ],
        },
        hyundai: {
            models: [
                'HB20',
                'Creta',
                'HB20S',
                'i30',
                'Tucson',
                'ix35',
                'HB20X',
                'Elantra',
                'Azera',
                'Santa Fe',
                'Veloster',
                'Sonata',
            ],
            images: [
                '/379453/HYUNDAI_HB20_1.0_TGDI_FLEX_PLATINUM_SAFETY_AUTOMATICO_3794531645596726.webp',
                '/379791/HYUNDAI_CRETA_1.6_TGDI_GASOLINA_ULTIMATE_DCT_37979110402385836.webp',
                '/379466/HYUNDAI_HB20S_1.0_TGDI_FLEX_PLATINUM_SAFETY_AUTOMATICO_37946616561421947.webp',
                '/347397/HYUNDAI_I30_1.8_MPI_16V_GASOLINA_SERIE_LIMITADA_4P_AUTOMATICO_34739715540420843.webp',
                '/347318/HYUNDAI_TUCSON_1.6_16V_TGDI_GASOLINA_LIMITED_ECOSHIFT_34731809010154692.webp',
                '/347051/HYUNDAI_IX35_2.0_MPFI_GL_16V_FLEX_4P_AUTOMATICO_34705108540091094.webp',
                '/348161/HYUNDAI_HB20X_1.6_16V_FLEX_DIAMOND_AUTOMATICO_34816115351307419.webp',
                '/346934/HYUNDAI_ELANTRA_2.0_16V_FLEX_SPECIAL_EDITION_4P_AUTOMATICO_34693415523719528.webp',
                '/348053/HYUNDAI_AZERA_3.0_V6_GDI_GASOLINA_AUTOMATICO_34805315430073762.webp',
                '/348194/HYUNDAI_SANTA_FE_3.5_V6_GASOLINA_7L_AWD_AUTOMATICO_34819415423756324.webp',
                '/343942/HYUNDAI_VELOSTER_1.6_16V_GASOLINA_3P_AUTOMATICO_34394215563084758.webp',
                '/343330/HYUNDAI_SONATA_2.4_MPFI_I4_16V_182CV_GASOLINA_4P_AUTOMATICO_34333015550302731.webp',
            ],
        },
        ford: {
            models: [
                'Fiesta',
                'Ka',
                'EcoSport',
                'Ranger',
                'Focus',
                'Fusion',
                'Ka+',
                'Mustang',
                'F-250',
                'F-150',
                'Edge',
                'Territory',
            ],
            images: [
                '/347460/FORD_FIESTA_1.0_ECOBOOST_GASOLINA_SEL_STYLE_POWERSHIFT_34746013455633955.webp',
                '/347772/FORD_KA_1.5_TIVCT_FLEX_SE_PLUS_MANUAL_34777210320322125.webp',
                '/347955/FORD_ECOSPORT_1.5_TIVCT_FLEX_TITANIUM_AUTOMATICO_INTERNA_34795510034208537.webp',
                '/379416/FORD_RANGER_3.0_V6_TURBO_DIESEL_CD_LIMITED_4X4_AUTOMATICO_37941614471812556.webp',
                '/348920/FORD_FOCUS_2.0_FC_16V_FLEX_4P_MANUAL_34892015120252690.webp',
                '/346877/FORD_FUSION_2.0_SEL_16V_GASOLINA_4P_AUTOMATICO_34687715131012623.webp',
                '/347783/FORD_KA_1.5_TIVCT_FLEX_TITANIUM_SEDAN_AUTOMATICO_34778310512876451.webp',
                '/379638/FORD_MUSTANG_5.0_V8_GASOLINA_GT_PERFORMANCE_SELECTSHIFT_37963812240602885.webp',
                '/379425/FORD_F250_6.7_V8_POWERSTROKE_DIESEL_SHELBY_SUPER_BAJA_CD_4WD_TORQSHIFT_37942521115120127.webp',
                '/349282/FORD_F150_5.0_V8_GASOLINA_CD_LARIAT_FX4_AUTOMATICO_34928216252140747.webp',
                '/347883/FORD_EDGE_2.7_V6_ECOBOOST_GASOLINA_ST_AWD_AUTOMATICO_34788310052331757.webp',
                '/348463/FORD_TERRITORY_1.5_ECOBOOST_GTDI_GASOLINA_TITANIUM_AUTOMATICO_34846312113599787.webp',
            ],
        },
        nissan: {
            models: [
                'Kicks',
                'Versa',
                'Frontier',
                'Sentra',
                'March',
                'GT-R',
                'Tiida',
                'Livina',
                'Grand Livina',
                '370Z',
                'Leaf',
            ],
            images: [
                '/348615/NISSAN_KICKS_1.6_16V_FLEXSTART_EXCLUSIVE_XTRONIC_34861520271942272.webp',
                '/348530/NISSAN_VERSA_1.6_16V_FLEX_EXCLUSIVE_XTRONIC_34853014070763343.webp',
                '/349004/NISSAN_FRONTIER_2.3_16V_TURBO_DIESEL_PLATINUM_CD_4X4_AUTOMATICO_34900419415243720.webp',
                '/379315/NISSAN_SENTRA_2.0_16V_GASOLINA_EXCLUSIVE_XTRONIC_37931520321872239.webp',
                '/347491/NISSAN_MARCH_1.6_SL_16V_FLEXSTART_4P_XTRONIC_34749109240548917.webp',
                '/346895/NISSAN_GTR_3.8_V6_BITURBO_GASOLINA_TRACK_AWD_AUTOMATIZADO_34689514592005734.webp',
                '/345699/NISSAN_TIIDA_1.8_SEDAN_16V_FLEX_4P_AUTOMATICO_34569915005264138.webp',
                '/343542/NISSAN_LIVINA_1.6_NIGHTDAY_16V_FLEX_4P_MANUAL_34354215000042624.webp',
                '/343023/NISSAN_GRAND_LIVINA_1.8_S_16V_FLEX_4P_MANUAL_34302314585953412.webp',
                '/345081/NISSAN_370Z_3.7_V6_GASOLINA_TOURING_AUTOMATICO_34508114570022563.webp',
                '/347880/NISSAN_LEAF_B12P_40_ELETRICO_34788014062859717.webp',
            ],
        },
        renault: {
            models: [
                'Sandero',
                'Kwid',
                'Logan',
                'Duster',
                'Duster Oroch',
                'Stepway',
                'Clio',
                'Captur',
                'Master',
                'Kangoo',
                'Scénic',
                'Megane',
            ],
            images: [
                '/348916/RENAULT_SANDERO_1.0_12V_SCE_FLEX_S_EDITION_MANUAL_34891614230572863.webp',
                '/347255/RENAULT_KWID_1.0_12V_SCE_FLEX_INTENSE_MANUAL_34725510272745957.webp',
                '/348080/RENAULT_LOGAN_1.0_12V_SCE_FLEX_ZEN_MANUAL_34808010423921089.webp',
                '/379585/RENAULT_DUSTER_1.3_TCE_FLEX_ICONIC_PLUS_XTRONIC_37958515192844113.webp',
                '/347155/RENAULT_DUSTER_OROCH_2.0_16V_HIFLEX_DYNAMIQUE_MANUAL_3471551625004942.webp',
                '/379373/RENAULT_STEPWAY_1.0_12V_SCE_FLEX_ZEN_MANUAL_37937311094165825.webp',
                '/344670/RENAULT_CLIO_1.0_EXPRESSION_16V_FLEX_4P_MANUAL_34467011591554191.webp',
                '/348778/RENAULT_CAPTUR_1.3_TCE_FLEX_ICONIC_XTRONIC_34877809350742888.webp',
                '/347065/RENAULT_MASTER_2.3_DCI_DIESEL_MINIBUS_EXECUTIVE_16L_L3H2_3P_MANUAL_34706515234433022.webp',
                '/379687/RENAULT_KANGOO_1.6_16V_SCE_FLEX_ADVANCED_MANUAL_37968710090072975.webp',
                '/341179/RENAULT_SCENIC_1.6_KIDS_16V_FLEX_4P_MANUAL_34117911595646166.webp',
                '/379511/RENAULT_MEGANE_60_KW_ELETRICO_ETECH_EV60_37951110575535885.webp',
            ],
        },
        jeep: {
            models: [
                'Compass',
                'Renegade',
                'Commander',
                'Grand-Cherokee',
                'Cherokee',
                'Wrangler',
                'Gladiator',
                'Patriot',
            ],
            images: [
                '/348655/JEEP_COMPASS_1.3_T270_TURBO_FLEX_LIMITED_AT6_34865516051398193.webp',
                '/379718/JEEP_RENEGADE_1.3_T270_TURBO_FLEX_SAHARA_AT6_37971816203558753.webp',
                '/348814/JEEP_COMMANDER_1.3_T270_TURBO_FLEX_OVERLAND_AT6_34881415574131625.webp',
                '/379520/JEEP_GRAND_CHEROKEE_2.0_TURBO_HIBRIDO_4XE_AT8_37952016161984248.webp',
                '/348452/JEEP_CHEROKEE_2.0_TURBO_GASOLINA_LIMITED_4X4_AUTOMATICO_34845214523355633.png',
                '/348141/JEEP_WRANGLER_2.0_TURBO_GASOLINA_RUBICON_4P_4X4_AT8_34814116265658085.webp',
                '/349114/JEEP_GLADIATOR_3.6_V6_GASOLINA_RUBICON_4P_4X4_AT8_34911418342051466.webp',
                '/346368/JEEP_PATRIOT_2.4_SPORT_4X4_16V_GASOLINA_4P_AUTOMATICO_34636814581550822.png',
            ],
        },
    },

    // motos
    motos: {
        honda: {
            models: ['CG 160 Fan', 'NXR 160 Bros ESDD', 'CG 160 Titan', 'Biz 125 ES', 'CB Twister'],
            images: generateImagesPathDefault(),
        },
        yamaha: {
            models: ['YS 250 Fazer', 'XTZ 250 Lander', 'FZ25 Fazer ABS', 'XT 660R', 'XTZ 250 Ténéré'],
            images: generateImagesPathDefault(),
        },
        bmw: {
            models: ['G 310 GS', 'F 800 GS', 'G 650 GS', 'S 1000 RR', 'R 1200 GS'],
            images: generateImagesPathDefault(),
        },
        kawasaki: {
            models: ['Ninja 250R', 'Z900', 'Ninja 300', 'ER-6N', 'Z750 ABS'],
            images: generateImagesPathDefault(),
        },
        suzuki: {
            models: ['Intruder 125', 'en 125 Yes ED', 'AN125 Burgman', 'Burgman i', 'GSX R1000'],
            images: generateImagesPathDefault(),
        },
        dafra: {
            models: ['Citycom 300i', 'NH 190', 'Citycom S 300i', 'Next 250', 'Zig 50'],
            images: generateImagesPathDefault(),
        },
        triumph: {
            models: ['Tiger 800 XCA', 'Tiger 800 XCx', 'Tiger 900 Rally Pro', 'Tiger 800 XRx', 'Tiger 800 XC'],
            images: generateImagesPathDefault(),
        },
        harleydavidson: {
            models: [
                'Sportster Iron 883',
                'Softail Fat Boy',
                'Softail Fat Boy 114',
                'Dyna Super Glide Custom',
                'Sportster XL 883 R',
            ],
            images: generateImagesPathDefault(),
        },
        shineray: {
            models: ['Jet 50', 'Jet 125', 'Shi 175', 'Phoenix S50', 'XY 150 Max'],
            images: generateImagesPathDefault(),
        },
        haojue: {
            models: ['DR 160 fi', 'Chopper Road 150', 'DK 150', 'Lindy 125 CBS', 'DK 150 CBS'],
            images: generateImagesPathDefault(),
        },
    },
};

export const PRIORITY_ORDER_CAR = [
    'Chevrolet',
    'Fiat',
    'Ford',
    'Honda',
    'Hyundai',
    'Jeep',
    'Nissan',
    'Renault',
    'Toyota',
    'Volkswagen',
];

export const PRIORITY_ORDER_BIKE = [
    'Bmw',
    'Dafra',
    'Haojue',
    'Harley-davidson',
    'Honda',
    'Kawasaki',
    'Shineray',
    'Suzuki',
    'Triumph',
    'Yamaha',
];

export const BRANDS_MAIN_CAR_WITH_MODELS = {
    Chevrolet: ['Onix', 'S10', 'Celta', 'Prisma', 'Corsa'],
    Volkswagen: ['Gol', 'Fox', 'Polo', 'Saveiro', 'Voyage'],
    Fiat: ['Uno', 'Palio', 'Strada', 'Toro', 'Argo'],
    Honda: ['Civic', 'Fit', 'HR-V', 'City', 'CR-V'],
    Toyota: ['Corolla', 'Hilux', 'Etios', 'Hilux SW4', 'Yaris'],
    Hyundai: ['HB20', 'Creta', 'HB20S', 'i30', 'Tucson'],
    Ford: ['Fiesta', 'Ka', 'EcoSport', 'Ranger', 'Focus'],
    Nissan: ['Kicks', 'Versa', 'Frontier', 'Sentra', 'March'],
    Renault: ['Sandero', 'Kwid', 'Logan', 'Duster', 'Duster Oroch'],
    Jeep: ['Compass', 'Renegade', 'Commander', 'Grand-Cherokee', 'Cherokee'],
};

export const BRANDS_MAIN_BIKE_WITH_MODELS = {
    Honda: ['CG 160 Fan', 'NXR 160 Bros ESDD', 'CG 160 Titan', 'Biz 125 ES', 'CB Twister'],
    Yamaha: ['YS 250 Fazer', 'XTZ 250 Lander', 'FZ25 Fazer ABS', 'XT 660R', 'XTZ 250 Ténéré'],
    BMW: ['G 310 GS', 'F 800 GS', 'G 650 GS', 'S 1000 RR', 'R 1200 GS'],
    Kawasaki: ['Ninja 250R', 'Z900', 'Ninja 300', 'ER-6N', 'Z750 ABS'],
    Suzuki: ['Intruder 125', 'en 125 Yes ED', 'AN125 Burgman', 'Burgman i', 'GSX R1000'],
    Dafra: ['Citycom 300i', 'NH 190', 'Citycom S 300i', 'Next 250', 'Zig 50'],
    Triumph: ['Tiger 800 XCA', 'Tiger 800 XCx', 'Tiger 900 Rally Pro', 'Tiger 800 XRx', 'Tiger 800 XC'],
    'Harley-Davidson': [
        'Sportster Iron 883',
        'Softail Fat Boy',
        'Softail Fat Boy 114',
        'Dyna Super Glide Custom',
        'Sportster XL 883 R',
    ],
    Shineray: ['Jet 50', 'Jet 125', 'Shi 175', 'Phoenix S50', 'XY 150 Max'],
    Haojue: ['DR 160 fi', 'Chopper Road 150', 'DK 150', 'Lindy 125 CBS', 'DK 150 CBS'],
};

export const BRANDS_MAIN_BIKE = [
    'honda',
    'yamaha',
    'bmw',
    'kawasaki',
    'suzuki',
    'triumph',
    'dafra',
    'harley-davidson',
    'shineray',
    'haojue',
    'royal-enfield',
    'ducati',
];

export const BRANDS_MAIN_CAR = [
    'chevrolet',
    'volkswagen',
    'fiat',
    'honda',
    'toyota',
    'hyundai',
    'ford',
    'nissan',
    'renault',
    'jeep',
    'mitsubishi',
    'bmw',
];

export const MODELS_BIKE_MOST_VIEWED = [
    {
        makeName: 'Honda',
        modelName: 'CG 160 Fan',
        versionLinkImage: '',
    },
    {
        makeName: 'Yamaha',
        modelName: 'YS 250 Fazer',
        versionLinkImage: '',
    },
    {
        makeName: 'Honda',
        modelName: 'NXR 160 Bros ESDD',
        versionLinkImage: '',
    },
    {
        makeName: 'Honda',
        modelName: 'CG 160 Titan',
        versionLinkImage: '',
    },
    {
        makeName: 'Honda',
        modelName: 'CB 600F Hornet',
        versionLinkImage: '',
    },
    {
        makeName: 'Yamaha',
        modelName: 'XTZ 250 Lander',
        versionLinkImage: '',
    },
];

export const MODELS_CAR_MOST_VIEWED = [
    {
        makeName: 'Chevrolet',
        modelName: 'Onix',
        versionLinkImage: '/348145/CHEVROLET_ONIX_1.0_TURBO_FLEX_PLUS_PREMIER_AUTOMATICO_34814517344963776',
    },
    {
        makeName: 'Toyota',
        modelName: 'Corolla',
        versionLinkImage: '/379444/TOYOTA_COROLLA_1.8_VVTI_HYBRID_FLEX_ALTIS_PREMIUM_CVT_37944417132188584',
    },
    {
        makeName: 'Honda',
        modelName: 'Civic',
        versionLinkImage: '/379390/HONDA_CIVIC_2.0_DI_VTEC_TURBO_GASOLINA_TYPE_R_MANUAL_37939013310558741',
    },
    {
        makeName: 'Volkswagen',
        modelName: 'Gol',
        versionLinkImage: '/349236/VOLKSWAGEN_GOL_1.0_12V_MPI_TOTALFLEX_LAST_EDITION_4P_MANUAL_34923608593742297',
    },
    {
        makeName: 'Honda',
        modelName: 'Fit',
        versionLinkImage: '/342096/HONDA_FIT_1.5_EX_16V_FLEX_4P_AUTOMATICO_34209616414322363',
    },
    {
        makeName: 'Hyundai',
        modelName: 'HB20',
        versionLinkImage: '/379453/HYUNDAI_HB20_1.0_TGDI_FLEX_PLATINUM_SAFETY_AUTOMATICO_3794531645596726',
    },
];

export const TEXT_TYPE_VEHICLE = {
    bikes: 'motos',
    cars: 'carros',
    bike: 'moto',
    car: 'carro',
};

export const YEARS_LIST = Array.from({ length: 30 }, (_, index) => {
    const year = new Date().getFullYear() - index;
    return {
        title: year,
        minPrice: undefined,
        maxPrice: undefined,
        href: `/${year}`,
    };
});

export const USE_CATALOG_API = true;

export const DEFAULT_TIMEOUT = 10000; // 10 segundos
